// NATIVE 
import { useEffect, useState } from 'react'

// INSTALLED 
import { useFormikContext } from 'formik';
import Divider from '@mui/material/Divider';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardActionArea, CardMedia, Grid } from '@mui/material';

// CUSTOM 
import { getImageStore } from '../../../store/files';
import { uploadImgStore } from '../../../store/uploaders';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';
import { CardActionImage } from '../../CardActionImage';





/**
 * LogosNombreComercialEditar component allows users to upload and preview commercial logos and post-commercial logos.
 * It uses Formik for form state management and Redux for state management.
 * 
 * @param {any} props - The properties passed to the component.
 * 
 * @returns {JSX.Element} The rendered component.
 * 
 * @component
 * 
 * @example
 * <LogosNombreComercialEditar formField={{ e_logo_bn_company: { name: 'logoCompany', label: 'Logo Company' }, e_logo_bn_post_company: { name: 'logoPostCompany', label: 'Logo Post Company' } }} />
 * 
 * @remarks
 * This component uses the following hooks:
 * - `useDispatch` from Redux to dispatch actions.
 * - `useFormikContext` from Formik to access form state.
 * - `useSelector` from Redux to access the company state.
 * - `useState` from React to manage local state for logo URLs, previews, file names, and upload percentages.
 * - `useEffect` from React to handle side effects such as setting initial logo previews and fetching logos from the store.
 * 
 * The component provides two main functionalities:
 * 1. Uploading and previewing the commercial logo.
 * 2. Uploading and previewing the post-commercial logo.
 * 
 * The component also handles file uploads and updates the Formik form state with the uploaded file information.
 */
export const LogosNombreComercialEditar = (props:any) => {


  // USE DISPATCH 
  const dispatch = useDispatch();


  // USE FORMIK CONTEXT 
  const formikProps:any = useFormikContext();


  // USE SELECTOR 
  const { company }:any  = useSelector( (state:any) => state.company );


  // USE STATE 
  const [logoUrlComercial, setLogoUrlComercial] = useState('');
  const [logoUrlPostComercial, setLogoUrlPostComercial] = useState('');


  const [preview_logo, setPreviewLogo] = useState('');
  const [file_n_name, setLogoFileName] = useState('');
  const [file_logo_comercial, setFileLogo] = useState(null);
  const [percentage_upload_logo, setPercentageUploadLogo] = useState(0);
  
 

  const [preview_post, setPreviewPost] = useState('');
  const [file_logo_post, setFilePost] = useState(null);
  const [file_post_name, setPostFileName] = useState('');
  const [percentage_upload_post, setPercentageUploadPost] = useState(0);
  
  


  const { formField: {
    e_logo_bn_company,
    e_logo_bn_post_company
  }
  } = props;




    // USE EFFECT 
    
    // VERIFICA QUE SI ESTA DEFINIDO EN EL FORMIK LOS LOGOS LOS PONE 
    // PORQUE EL STEPER LO BORRA AL VOLVER 
    useEffect(() => {
      
        if (formikProps.values.e_logo_bn_company) {
            const objectURL = URL.createObjectURL(formikProps.values.e_logo_bn_company);
            setPreviewLogo(objectURL);
            setPercentageUploadLogo(100);
        }

        if (formikProps.values.e_logo_bn_post_company) {
            const objectURL = URL.createObjectURL(formikProps.values.e_logo_bn_post_company);
            setPreviewPost(objectURL);
            setPercentageUploadPost(100);
        }

    }, []);


    useEffect(() => {
      // console.log('telefonnonon ',  props)
      getLogoCompanyComercial(company.logo_company);
      getLogoPostCompanyComercial(company.logo_post_company)
    }, []);
    


    // CONST FUNCTIONS 
    const getLogoCompanyComercial = async(imageName:string) => { 
        setLogoUrlComercial(imageName);
    }


    const getLogoPostCompanyComercial = async(imageName:string) => { 
      setLogoUrlPostComercial(imageName);
    }
    

    const uploadFileLogo = async({ target }:any) => {


            
      const { name } = target.files[0];

      setLogoFileName(name);
      setFileLogo(target.files[0]);

      const objectURL = URL.createObjectURL(target.files[0]);
      setPreviewLogo(objectURL);
  
      formikProps.setFieldValue('e_logo_bn_company', target.files[0]);
      const { ok, data } = await dispatch( uploadImgStore( 'image-company', target.files[0], setPercentageUploadLogo) );
    
      console.log(data)
      if (ok) {
         formikProps.setFieldValue('e_logo_bn_company_name_saved_file', data.imgName);
      }


    }

    const uploadFileLogoPost = async({ target }:any) => {
   
      
      const { name } = target.files[0];
      setPostFileName(name);
      setFilePost(target.files[0]);

      const objectURL = URL.createObjectURL(target.files[0]);
      setPreviewPost(objectURL);

      formikProps.setFieldValue('e_logo_bn_post_company', target.files[0]);
      const { ok, data } = await dispatch( uploadImgStore( 'image-company', target.files[0], setPercentageUploadPost) );
    
      if (ok) {
         formikProps.setFieldValue('e_logo_bn_rz_post_company_name_saved_file', data.imgName);
      }
  
      
    }

  return (
    <div>
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <Button>  Sube Tu Logo Comercial</Button>
                <Divider/>
                <UploadButtonField onChange={uploadFileLogo} 
                                   accept={'image/*'} 
                                   name={e_logo_bn_company.name} 
                                   label={e_logo_bn_company.label} 
                                   text={'Subir Archivo'} />
                
                {
                  formikProps.values.e_logo_bn_company
                       ?
                       <>
                       

                       <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Card sx={{ maxWidth: 350, marginTop: 7 }}>
                            <CardActionArea>
                              <CardMedia
                                component="img"
                                height="250"
                                sx={{ objectFit: 'fill' }}
                                image={preview_logo}
                                alt="Logo compañia"
                              />
                            </CardActionArea>
                          </Card>
                          
                        </div>
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                            <LinearProgressWithLabel percentage={percentage_upload_logo} label={formikProps.values.e_logo_bn_company.name} hasIcon={false} />
                        </Card>
                       </>
                       :
                       <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <CardActionImage urlImage={logoUrlComercial} typeImage={'company'} />
                        </div>
                }
            </Grid>
            <Grid item xs={6}>
                <Button>  Sube Tu Logo Post Comercial</Button>
                <Divider/>
                <UploadButtonField onChange={uploadFileLogoPost} 
                                   accept={'image/*'} 
                                   name={e_logo_bn_post_company.name} 
                                   label={e_logo_bn_post_company.label} 
                                   text={'Subir Archivo'} />
                
                {
                  formikProps.values.e_logo_bn_post_company
                       ?
                        <>
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Card sx={{ maxWidth: 350, marginTop: 7 }}>
                              <CardActionArea>
                                <CardMedia
                                  component="img"
                                  height="250"
                                  sx={{ objectFit: 'fill' }}
                                  image={preview_post}
                                  alt="green iguana"
                                />
                              </CardActionArea>
                            </Card>
                          </div>
                          <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                            <LinearProgressWithLabel percentage={percentage_upload_post} label={formikProps.values.e_logo_bn_post_company.name} hasIcon={false} />
                          </Card>
                        </>
                       :
                       <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <CardActionImage urlImage={logoUrlPostComercial} typeImage={'company'} />
                        </div>
                }
            </Grid>
        </Grid>
    </div> 
  )
}
